export default __webpack_public_path__ + "static/media/Supply-Drive-website.f1c60d57.jpg";